import { take, put, all } from "redux-saga/effects";

import { SET_SESSION_DATA, CREATE_SESSION } from "../../actions/sessionActions";
import { StringMap, SessionInitData } from "../../../api/generated/models";

import client from "../../../api/client/SdsWebApiClient";
import { getFrontendSettings, loadConfigurationFiles } from "../../../utilities/configUtils";
import Constants from "../../../constants";
import { SummaryConfig } from "../../../models/summaryConfig";

export function* createSessionSaga() {
    yield take(CREATE_SESSION);

    const clientSettingsPromise = client.getClientSettingsGet();
    const frontendSettingsPromise = getFrontendSettings();

    const searchParams = new URLSearchParams(window.location.search);
    let language = searchParams.get(Constants.languageUrlQueryParam) || (yield client.getDefaultLanguageGet());
    language = language.toUpperCase();

    const dealerAccount = searchParams.get(Constants.dealerAccountUrlQueryParam) || "KUND1";
    const configsPromise = loadConfigurationFiles(language);
    const sessionData: SessionInitData = yield client.createSessionPost(dealerAccount, language);

    const market = searchParams.get(Constants.marketUrlQueryParam);
    if (market) {
        yield client.setSessionPriceLocalizationPost(sessionData.sessionId, market);
    }

    const [[appConfig, summaryData], applicationSettings, frontendSettings]: [[Object, SummaryConfig], StringMap, any] =
        yield all([configsPromise, clientSettingsPromise, frontendSettingsPromise]);

    let showPrice = applicationSettings.dict.find(x => x.key === "price.enable")?.value === "True";
    const hidePrice = searchParams.get("hide_price");
    if (
        (hidePrice && /true/i.test(hidePrice)) ||
        frontendSettings.hide_price === true ||
        /true/i.test(frontendSettings.hide_price)
    ) {
        showPrice = false;
    }

    let showCancelButton = true;
    const hideCancel = searchParams.get("hide_cancel");
    if (hideCancel && /true/i.test(hideCancel)) {
        showCancelButton = false;
    }

    let approximatePrices = false;
    const approxPrice = searchParams.get("approx_price");
    if (approxPrice && /true/i.test(approxPrice)) {
        approximatePrices = true;
    }

    yield put({
        type: SET_SESSION_DATA,
        sessionData,
        frontendSettings,
        appConfig,
        summaryData,
        applicationSettings,
        language,
        showPrice,
        showCancelButton,
        approximatePrices,
        dealerAccount,
    });
}
